export default "__VITE_ASSET__Dqq6uTE1__"